<template>
    <table class="w-full max-w-2xl">
        <thead>
            <tr class="text-left font-bold">
                <th>Quantity</th>
                <th>Price / Unit</th>
                <th>Discount</th>
            </tr>
        </thead>

        <tbody>
            <tr
                v-for="pricingTier in formattedPricingTiers"
                :key="pricingTier.quantityBreak"
            >
                <td class="pt-4">
                    {{ pricingTier.formattedQuantityBreak }}
                </td>
                <td class="pt-4">{{ pricingTier.formattedPrice }}</td>
                <td class="pt-4">{{ pricingTier.formattedDiscount }}</td>
            </tr>
        </tbody>
    </table>
</template>

<script setup lang="ts">
import { PricingTier } from '~/types/miscellaneous';
import { commaNumber, formatCurrency } from '~/utils/helpers';

interface FormattedPricingTier extends PricingTier {
    formattedQuantityBreak: string;
    formattedPrice: string;
    formattedDiscount: string | null;
}

const props = defineProps<{
    pricingTiers: PricingTier[];
}>();

const formattedPricingTiers = computed<FormattedPricingTier[]>(() => {
    const lowestPrice = props.pricingTiers[0].price;

    return props.pricingTiers.map((pricingTier) => {
        let formattedDiscount = null;
        if (pricingTier.price < lowestPrice) {
            const discount = (1 - pricingTier.price / lowestPrice) * 100;

            formattedDiscount = `${Math.round(discount)}% Savings`;
        } else {
            formattedDiscount = 'No quantity discount';
        }

        return {
            ...pricingTier,
            formattedQuantityBreak: commaNumber(pricingTier.quantityBreak),
            formattedPrice: formatCurrency(pricingTier.price),
            formattedDiscount,
        };
    });
});
</script>
